import { Alert, Box } from '@mui/material';
import { Button, theme } from '@theguarantors/tg-package-material-ui';
import { Fragment } from 'react';
import { useFormState } from 'react-hook-form';

import { Tooltip } from '@/shared/components/Tooltip';

import { useInviteFormRuntime } from './invite-lease-details.runtime-context';

// The sticky "Send Invite" footer, rendered inside <LeaseDetailsForm>'s form via
// `ui.slots.bottom` (the engine's own actions are hidden via
// `ui.hideDefaultActions`). `type="submit"` drives the engine's handleSubmit.
// Markup mirrors the legacy InviteLeaseDetailsDrawerForm footer for parity.
export function InviteLeaseDetailsSharedFooter() {
  // Scoped subscription: only the footer re-renders when validity/submitting flips.
  const { isValid, isSubmitting } = useFormState();
  const { errorMsg } = useInviteFormRuntime();

  return (
    <Fragment>
      {errorMsg ? (
        <Alert severity="error" sx={{ marginY: 2 }}>
          {errorMsg}
        </Alert>
      ) : null}
      <Box
        sx={{
          position: 'sticky',
          bottom: -1,
          backgroundColor: 'background.paper',
          borderTop: `1px solid ${theme.palette.neutralGrey[200]}`,
          pt: 2,
          pb: 2,
          mt: 2,
          zIndex: 100,
          mx: -4,
          px: 4,
        }}
      >
        <Tooltip title={!isValid ? 'Please complete the required fields to proceed' : ''}>
          <Box>
            <Button
              variant="contained"
              type="submit"
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              id="RenterInviteSubmitButton"
              style={!isValid || isSubmitting ? { pointerEvents: 'none' } : {}}
              sx={{ width: '100%', height: '55px' }}
            >
              Send Invite
            </Button>
          </Box>
        </Tooltip>
      </Box>
    </Fragment>
  );
}
